import React from "react";
import PropTypes from "prop-types";
import { Icon, useBreakpoints } from "@qgiv/core-react";
import { Button, BackButton } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";
import ModalStateContext from "../../ModalStateContext";

const JoinTeamFooter = ({
    backLinkLabel,
    isCms,
    createTeamButtonLabel,
    displayTeamLimitReached = false,
    hasSelectedTeam,
    setFieldValue,
    enableCreateTeam = false,
    formattedTeamLimitLabel = "",
    setAppTeamModalOpen = () => {},
}) => {
    const dispatch = useDispatch();
    const { toggleActiveView } = React.useContext(ModalStateContext);

    const { isSmallScreen } = useBreakpoints();

    return (
        <>
            {!isSmallScreen && (
                <div className="col col--6">
                    <BackButton
                        handleClick={() => {
                            if (!hasSelectedTeam) {
                                setFieldValue("Registration_Role", []);
                            }
                            dispatch(setAppTeamModalOpen(false));
                        }}
                        backLinkLabel={backLinkLabel}
                        isCms={isCms}
                        centered
                    />
                </div>
            )}

            {enableCreateTeam && (
                <div className="col col--12 col--sm-6">
                    <Button
                        btnStyle="secondary"
                        type="button"
                        onClick={() => {
                            toggleActiveView();
                        }}
                    >
                        <Icon
                            className="-type--xlarge -margin-right--10"
                            glyph="users-solid"
                            type="FontAwesome"
                        />
                        <span>{createTeamButtonLabel}</span>
                    </Button>
                </div>
            )}
            {displayTeamLimitReached && (
                <div className="col col--12 -text--center">
                    <p className="-margin-top--10">
                        <strong>
                            <Icon type="FontAwesome" glyph="users-solid" />{" "}
                            {formattedTeamLimitLabel}
                        </strong>
                    </p>
                </div>
            )}
        </>
    );
};

JoinTeamFooter.propTypes = {
    backLinkLabel: PropTypes.string.isRequired,
    // Flag for which version of the back button to display
    isCms: PropTypes.bool.isRequired,
    createTeamButtonLabel: PropTypes.string.isRequired,
    // Flag to show team limit reached notification instead of join team btn
    displayTeamLimitReached: PropTypes.bool,
    // Setting flag to determine if modal should allow team creating
    enableCreateTeam: PropTypes.bool,
    // Label likely from cms data that should be displayed when team limit is reached
    formattedTeamLimitLabel: PropTypes.string,
    // Redux action to update team modal open flag
    setAppTeamModalOpen: PropTypes.func,
    setFieldValue: PropTypes.func.isRequired,
    hasSelectedTeam: PropTypes.bool.isRequired,
};

export default JoinTeamFooter;
